/* --------------------------------------------------------------------------------------
   MFDApp.const.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/


// First item on securedRoutes is the default route after authentication

export const MFDApp = {
  theme: "green",
  storagePrefix: "xho-",
  securedRoutes: [
    '/queues', 
    '/scan'
  ],
  scanSettings: {
    items: [
      'TwoSided',
      'Resolution',
      'OutputColor',
      'OriginalType',
      'OriginalOrientation',
      'OriginalSize',
      'Quality'
    ],
    customDefaults: {
      Resolution: "300",
      Quality: "MediumCompression"
    }
  }
};